import SummaryContent from '@/components/booking-summary/SummaryContent';
import PriceDisplay from '@/components/PriceDisplay';
import type { BookingSummaryData } from '@/hooks/useBookingSummaryData';
import { TransText } from '@/i18n/trans/text';
import { Card, Divider, Icons, Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

const RegularBookingSummary: FC<BookingSummaryData> = ({
  displayPrice,
  ...props
}) => {
  return (
    <Card className="w-[320px] p-0">
      <SummaryContent {...props} />
      <Divider variant="medium" className="border-primary" />
      <div className="flex flex-row justify-between p-4">
        <div className="flex gap-2">
          <Icons.shoppingCart className="text-primary" />
          <Typography variant="body1-bold">
            <TransText i18nKey="totalPrice" />
          </Typography>
        </div>
        <Typography variant="subtitle" className="text-primary">
          <PriceDisplay amount={displayPrice?.amount} />
        </Typography>
      </div>
    </Card>
  );
};

export default RegularBookingSummary;
